import React from 'react';

import { PrivateLayout } from '~/Layout/PrivateLayout';
import { useOrgMerchantListDesktopTableDefinition } from './useOrgMerchantListDesktopTableDefinition';
import { FitoListReactQuery } from '~/Components';
import { IMerchant } from '~/Models/DTO/Merchant.models';
import { useMerchantList } from './useMerchantList';
import { useRequestMerchants } from '~/requests/providerService/useRequestMerchants';

export const MerchantList = () => {
  const MerchantListDesktopTableDefinition = useOrgMerchantListDesktopTableDefinition();
  const { keyOfId, title, titleAsString, settings, setItemValues } = useMerchantList();
  const merchantResponse = useRequestMerchants();
  const PAGE_SIZE = merchantResponse?.data?.length > 10 ? merchantResponse?.data?.length : 10;
  const getQueryResults = (query: any) => ({ ...merchantResponse, ...query });
  return (
    <PrivateLayout title={title} hideBackButton>
      <FitoListReactQuery<IMerchant>
        keyOfId={keyOfId}
        settings={settings}
        title={titleAsString}
        setItemValues={setItemValues}
        tableDefinition={MerchantListDesktopTableDefinition}
        queryResults={getQueryResults}
        pageSize={PAGE_SIZE}
      />
    </PrivateLayout>
  );
};
